function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { List, Button, Space, Skeleton, Drawer, Tag } from "antd";
import { CashStack } from "react-bootstrap-icons";
import CashInLearningFee from "./forms/CashInLearningFee";
import CashIn from "./forms/CashIn";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var InSession = function InSession(_ref) {
  var session = _ref.session;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    pboxVisible = _useState2[0],
    setPboxVisible = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentAttendant = _useState4[0],
    setCurrentAttendant = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedInvoice = _useState6[0],
    setSelectedInvoice = _useState6[1];
  var handlePay = function handlePay(a, i) {
    setCurrentAttendant(a);
    setSelectedInvoice(i);
    setPboxVisible(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(List, {
      itemLayout: "horizontal",
      dataSource: session.attendant_learning_sessions,
      renderItem: function renderItem(item) {
        return /*#__PURE__*/_jsxs(List.Item, {
          actions: [/*#__PURE__*/_jsx("a", {
            onClick: function onClick() {
              handlePay(item.attendant, item.bill);
            },
            children: /*#__PURE__*/_jsx(CashStack, {
              size: 20
            })
          })],
          children: [/*#__PURE__*/_jsx(List.Item.Meta, {
            title: /*#__PURE__*/_jsx("b", {
              children: item.attendant.name
            }),
            description: /*#__PURE__*/_jsxs("p", {
              children: ["Tel. ", item.attendant.mobile, " - Pay\xE9 : ", item.bill != null && /*#__PURE__*/_jsx("span", {
                children: item.bill.paid_amount.toLocaleString("Fr")
              }), ", Reste \xE0 payer: ", item.bill != null && (item.bill.total_amount - item.bill.paid_amount).toLocaleString("Fr")]
            })
          }), /*#__PURE__*/_jsx("div", {})]
        });
      }
    }), currentAttendant != null && selectedInvoice != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: "ENCAISSEMENT"
      }),
      width: "420px",
      open: pboxVisible,
      onClose: function onClose() {
        setPboxVisible(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Tag, {
          color: "#f50",
          children: "Participant"
        }), /*#__PURE__*/_jsx("h5", {
          children: /*#__PURE__*/_jsx("b", {
            children: currentAttendant.name
          })
        }), /*#__PURE__*/_jsx(Tag, {
          color: "#1780A5",
          children: "Formation"
        }), /*#__PURE__*/_jsx("h6", {
          children: /*#__PURE__*/_jsx("b", {
            children: session.label
          })
        }), /*#__PURE__*/_jsx(CashIn, {
          invoice: selectedInvoice,
          handler: function handler() {
            setPboxVisible(false);
            notification.success({
              message: "Encaissement éffectué"
            });
          },
          session: session
        })]
      })
    })]
  });
};
export default InSession;